
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div id=\"communication-preferences\" class=\"settings-unit\">\n    <div class=\"settings-unit-stub\">\n        <header class=\"settings-unit-summary\">\n            <h2 class=\"settings-unit-title\">\n                <a class=\"open-email-preferences\" href=\"{{{ escapedEmailPreferencesLink }}}\" target=\"_blank\" data-flow-event=\"link.email-preferences\">{{#t}}Email preferences{{/t}}</a>\n            </h2>\n        </header>\n    </div>\n</div>\n"
      return mustache.render(src, view, partials);
    };
  